import { defineMessages } from 'react-intl';

export const templatePageMessages = defineMessages({
  title: {
    id: 'templates.title',
    defaultMessage: 'Tailoring Proposals',
    description: 'Templates page headline and navigation button',
  },
  addTemplate: {
    id: 'templates.addTemplate',
    defaultMessage: 'Add Tailoring Proposal',
    description: 'Add template button',
  },
  searchBarPlaceholder: {
    id: 'templates.searchBarPlaceholder',
    defaultMessage: 'Search Tailoring Proposals',
    description: 'Search templates placeholder',
  },

  filterBarText: {
    id: 'templates.filterBarText',
    defaultMessage: 'Show:',
    description: 'Filter bar text',
  },
  filterBarOptionAllTemplates: {
    id: 'templates.filterBarOptionAllTemplates',
    defaultMessage: 'All Tailoring Proposals',
    description: 'Filter bar option all templates',
  },
  filterBarOptionBuTemplates: {
    id: 'templates.filterBarOptionBuTemplates',
    defaultMessage: 'BU Tailoring Proposals',
    description: 'Filter bar option bu templates',
  },
  filterBarOptionMyTemplates: {
    id: 'templates.filterBarOptionMyTemplates',
    defaultMessage: 'My Tailoring Proposals',
    description: 'Filter bar option my templates',
  },

  gridViewButton: {
    id: 'templates.gridViewButton',
    defaultMessage: 'Grid view',
    description: 'Grid view button',
  },
  tableViewButton: {
    id: 'templates.tableViewButton',
    defaultMessage: 'Table view',
    description: 'Table view button',
  },

  noResults: {
    id: 'templates.noResults',
    defaultMessage: 'No Tailoring Proposals have been created yet.',
    description: 'Templates page no results message',
  },
  noResultsButton: {
    id: 'templates.noResultsButton',
    defaultMessage: 'Create new Tailoring Proposal',
    description: 'Templates page no results button',
  },
  noTemplatesFound: {
    id: 'templates.noTemplatesFound',
    defaultMessage: 'No Tailoring Proposals found for the current search query.',
    description: 'Templates page no templates found message',
  },
});
